import store from '@/vuex/store'
import router from '@/router/index.js'
import axios from 'axios'
import Lockr from 'lockr'
import Cookies from 'js-cookie'
import _ from 'lodash'
import _g from '@/assets/js/global'
import bus from '@/assets/js/bus.js'
import config from '@/assets/js/config.js'
import baseHttp from '@/assets/js/base_http.js'

axios.defaults.baseURL = process.env.NODE_ENV === 'production' ? config.PROD_HOST : config.HOST
axios.defaults.timeout = 1000 * 15
axios.defaults.headers.authKey = Lockr.get('authKey')
axios.defaults.headers['Content-Type'] = 'application/json'

const apiMethods = {
  methods: {
    ...baseHttp,
    handelResponse(res, cb, errCb) {
      _g.closeGlobalLoading()
      if (res.code == 200) {
        cb(res.data)
      } else {
        // if (typeof errCb == 'function') {
        //   errCb()
        // }
        cb(res.data)
        // this.handleError(res)
      }
    },
    handleError(res) {
      if (res.code) {
        switch (res.code) {
          case 101:
            if (Cookies.get('rememberPwd')) {
              let data = {
                rememberKey: Lockr.get('rememberKey')
              }
                                // this.reAjax('shanaikanrisha/base/relogin', data).then((res) => {
                                //   this.handelResponse(res, (data) => {
                                //     this.resetCommonData(data, '')
                                //   })
                                // })
            } else {
              _g.toastMsg('error', res.error)
              setTimeout(() => {
                router.replace('/')
              }, 1500)
            }
            break
          case 103:
            _g.toastMsg('error', res.error)
            setTimeout(() => {
              router.replace('/')
            }, 1500)
            break
                        // case 400:
                        //   this.goback()
                        //   break
          default:
            _g.toastMsg('error', res.error)
        }
      } else {}
    },
    resetCommonData(url) {
      setTimeout(() => {
        if (url !== '') {
          let path = this.$route.path
          if (url != path) {
            router.replace(url)
          } else {
            _g.shallowRefresh(this.$route.name)
          }
        }
      }, 1000)
    }

  },
  computed: {
    showLoading() {
      return store.state.globalLoading
    }
  }
}

export default apiMethods



// WEBPACK FOOTER //
// ./src/assets/js/http.js